import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { storageKey } from 'libs/core/src/app.const';
import { NavigationService } from 'libs/core/src/lib/service/navigation/navigation.service';
import { StateService } from 'libs/core/src/lib/state/state.service';
import { ENVIRONMENT_TOKEN } from 'libs/core/src/public-api';

@Component({
  selector: 'app-page-home',
  template: '',
  standalone: false,
})
export class HomePageComponent implements OnInit {
  constructor(
    @Inject(ENVIRONMENT_TOKEN) protected environment: any,
    private router: Router,
    private route: ActivatedRoute,
    private stateService: StateService,
    private navigationService: NavigationService,
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (this.environment.startOnPlayground) {
        this.navigationService.goTo(['playground']);
        return;
      }

      if (!params.screeningId) {
        this.navigationService.goTo(['screening']);
      } else if (params.screeningId !== undefined) {
        this.navigationService.goTo(['screen', params.screeningId]);
      } else {
        const location = this.stateService.getItem(storageKey.backUrl);
        window.location.href = location ? location : this.environment.backUrl;
      }
    });
  }
}
